// Multi-language route registry - única fuente de verdad
const BASE_URL = 'https://www.bluecmr.com';
const DEFAULT_LANG = 'es';
const LANGUAGES = ['es', 'en', 'fr'];

// Páginas lógicas con rutas y SEO por idioma
const PAGES = {
  home: {
    slug: { es: '', en: 'en', fr: 'fr' },
    seo: {
      // 4-nov-2026: home B2B, documentos de transporte digitales (ya no centrada en el DeCA)
      es: { title: 'Documentos de transporte digitales: eCMR, carta de porte y DeCA | BlueCMR', description: 'Documentos de transporte digitales con validez legal: eCMR, carta de porte, DeCA y ADR, con firma electrónica avanzada e integración con su TMS o ERP.', keywords: 'documentos de transporte digitales, ecmr digital, carta de porte electrónica, deca, documento electrónico de control administrativo, documento de transporte adr', type: 'website' },
      en: { title: 'Digital transport documents: eCMR and consignment notes | BlueCMR', description: 'Digital transport documents with full legal validity: eCMR, consignment notes, control documents and ADR, with advanced e-signature and TMS or ERP integration.', keywords: 'digital transport documents, ecmr, electronic consignment note, efti', type: 'website' },
      fr: { title: 'eCMR, Document de Contrôle et Lettre de Voiture Numérique | BlueCMR', description: 'BlueCMR numérise les Documents de Contrôle, Lettres de Voiture et eCMR avec validité légale (Loi 15/2009, eIDAS, EFTI).', keywords: 'document contrôle, ecmr numérique, lettre voiture électronique', type: 'website' }
    }
  },
  platform: {
    slug: { es: 'plataforma', en: 'en/platform', fr: 'fr/plateforme' },
    seo: {
      es: { title: 'Plataforma de documentos de transporte digitales: cómo funciona | BlueCMR', description: 'Cómo gestiona BlueCMR el ciclo de vida de sus documentos de transporte: creación, envío, firma electrónica, eventos en ruta, cierre y conservación con evidencias.', keywords: 'plataforma documentos de transporte, ecmr, carta de porte digital, deca', type: 'website' },
      en: { title: 'Digital transport documents platform: how it works | BlueCMR', description: 'How BlueCMR manages the lifecycle of your transport documents: creation, sending, electronic signature, events on the road, closing and preservation with evidence.', keywords: 'transport documents platform, ecmr platform, electronic consignment note', type: 'website' },
      fr: { title: 'Plateforme eCMR et Documents de Transport Numériques | BlueCMR', description: 'Plateforme complète pour gérer les documents de transport numériques: eCMR, Lettre de Voiture, Document de Contrôle.', keywords: 'plateforme ecmr, documents transport numériques', type: 'website' }
    }
  },
  interoperability: {
    slug: { es: 'interoperabilidad', en: 'en/interoperability', fr: 'fr/interoperabilite' },
    seo: {
      es: { title: 'Integración y API para documentos de transporte: TMS, ERP y flotas | BlueCMR', description: 'Conecte BlueCMR con su TMS, ERP, sistema de flota o portal de clientes: API REST, webhooks, enlaces embebidos y ficheros en cualquier formato, con datos conformes al marco eFTI.', keywords: 'interoperabilidad transporte, integración documentos de transporte, api documentos de transporte, webhooks transporte, integración tms erp, efti', type: 'website' },
      en: { title: 'Integration and API for transport documents | BlueCMR', description: 'Connect BlueCMR to your TMS, ERP or customer portal: REST API, webhooks, embedded links and files in any format, with data following eFTI.', keywords: 'transport interoperability, transport document integration, transport document api, transport webhooks, tms erp integration, efti', type: 'website' },
      fr: { title: 'Interopérabilité et Conformité EFTI | BlueCMR', description: 'Interopérabilité totale avec les systèmes TMS, ERP et plateformes de visibilité.', keywords: 'interopérabilité efti, intégration tms', type: 'website' }
    }
  },
  trust: {
    slug: { es: 'confianza', en: 'en/trust', fr: 'fr/confiance' },
    seo: {
      es: { title: 'Seguridad y Confianza Digital | BlueCMR', description: 'Máxima seguridad con firma electrónica avanzada, sellado de tiempo y cumplimiento eIDAS.', keywords: 'firma electronica avanzada, eidas', type: 'website' },
      en: { title: 'Security and Digital Trust | BlueCMR', description: 'Maximum security with advanced electronic signature, timestamping and eIDAS compliance.', keywords: 'advanced electronic signature, eidas', type: 'website' },
      fr: { title: 'Sécurité et Confiance Numérique | BlueCMR', description: 'Sécurité maximale avec signature électronique avancée, horodatage et conformité eIDAS.', keywords: 'signature électronique avancée, eidas', type: 'website' }
    }
  },
  contact: {
    slug: { es: 'contacto', en: 'en/contact', fr: 'fr/contact' },
    seo: {
      es: { title: 'Contacto | BlueCMR', description: 'Contacta con BlueCMR para digitalizar tus documentos de transporte.', keywords: 'contacto bluecmr, solicitar demo', type: 'website' },
      en: { title: 'Contact | BlueCMR', description: 'Contact BlueCMR to digitize your transport documents.', keywords: 'contact bluecmr, request demo', type: 'website' },
      fr: { title: 'Contact | BlueCMR', description: 'Contactez BlueCMR pour numériser vos documents de transport.', keywords: 'contact bluecmr, demander démo', type: 'website' }
    }
  },
  demo: {
    slug: { es: 'demo', en: 'en/demo', fr: 'fr/demo' },
    seo: {
      es: { title: 'Demo Gratuita | BlueCMR', description: 'Solicita una demo gratuita de BlueCMR.', keywords: 'demo bluecmr', type: 'website' },
      en: { title: 'Free Demo | BlueCMR', description: 'Request a free demo of BlueCMR.', keywords: 'bluecmr demo', type: 'website' },
      fr: { title: 'Démo Gratuite | BlueCMR', description: 'Demandez une démo gratuite de BlueCMR.', keywords: 'démo bluecmr', type: 'website' }
    }
  },
  privacy: {
    slug: { es: 'privacidad', en: 'en/privacy', fr: 'fr/confidentialite' },
    seo: {
      es: { title: 'Política de Privacidad | BlueCMR', description: 'Política de privacidad de BlueCMR.', keywords: 'privacidad', type: 'website' },
      en: { title: 'Privacy Policy | BlueCMR', description: 'How BlueCMR S.L.U. processes your personal data: controller, purposes, legal bases, retention periods and how to exercise your GDPR rights.', keywords: 'privacy policy, gdpr, personal data, bluecmr', type: 'website' },
      fr: { title: 'Politique de Confidentialité | BlueCMR', description: 'Politique de confidentialité de BlueCMR.', keywords: 'confidentialité', type: 'website' }
    }
  },
  cookies: {
    slug: { es: 'cookies', en: 'en/cookies', fr: 'fr/cookies' },
    seo: {
      es: { title: 'Política de Cookies | BlueCMR', description: 'Política de cookies de BlueCMR.', keywords: 'cookies', type: 'website' },
      en: { title: 'Cookie Policy | BlueCMR', description: 'Information about the use of cookies on the BlueCMR S.L.U. website.', keywords: 'cookie policy, cookies, bluecmr', type: 'website' },
      fr: { title: 'Politique de Cookies | BlueCMR', description: 'Politique de cookies de BlueCMR.', keywords: 'cookies', type: 'website' }
    }
  },
  articles: {
    slug: { es: 'articulos', en: 'en/articles', fr: 'fr/articles' },
    seo: {
      es: { title: 'Artículos | BlueCMR', description: 'Artículos sobre digitalización del transporte.', keywords: 'articulos transporte', type: 'website' },
      en: { title: 'Articles | BlueCMR', description: 'Articles about transport digitization.', keywords: 'transport articles', type: 'website' },
      fr: { title: 'Articles | BlueCMR', description: 'Articles sur la numérisation du transport.', keywords: 'articles transport', type: 'website' }
    }
  }
};

const DOCUMENT_PAGES = {
  ecmr: {
    slug: { es: 'documentos/ecmr', en: 'en/documents/ecmr', fr: 'fr/documents/ecmr' },
    seo: {
      es: { title: 'eCMR: qué es, validez legal y si es obligatorio en España | BlueCMR', description: 'El eCMR es el CMR en formato electrónico, con la misma validez que el papel según el Protocolo eCMR: cómo funciona, dónde vale y si es obligatorio en España.', keywords: 'ecmr, ecmr validez legal, ecmr obligatorio españa, cmr electrónico', type: 'article' },
      en: { title: 'eCMR: what it is, legal validity and how it works | BlueCMR', description: 'The eCMR is the electronic CMR consignment note, legally equivalent to paper under the eCMR Protocol: how it works, where it is valid and how BlueCMR issues it.', keywords: 'ecmr, electronic cmr, ecmr protocol, electronic consignment note', type: 'article' },
      fr: { title: 'eCMR Numérique | BlueCMR', description: 'eCMR numérique avec validité légale.', keywords: 'ecmr numérique', type: 'article' }
    }
  },
  documentoControl: {
    langs: ['es', 'en'], // EN desde el 4-nov-2026 (versión inglesa completa); FR no existe.
    slug: { es: 'documentos/documento-control', en: 'en/documents/control-document', fr: 'fr/documents/document-controle' },
    seo: {
      es: { title: 'DeCA de transporte: el documento de control electrónico obligatorio | BlueCMR', description: 'El DeCA (antes DCA o documento de control) es obligatorio en formato electrónico en el transporte nacional: qué exige la norma y cómo emitirlo con BlueCMR.', keywords: 'DeCA, documento electrónico de control administrativo, documento de control, DCA', type: 'article' },
      en: { title: 'DeCA: Spain’s electronic control document for road haulage | BlueCMR', description: 'The DeCA, Spain’s electronic control document, is mandatory for domestic road haulage in Spain: what the rules require and how to issue it with BlueCMR.', keywords: 'deca, deca spain, spanish control document, documento de control, electronic control document spain, dca, cabotage spain, order fom/2861/2012', type: 'article' },
      fr: { title: 'Document de Contrôle Numérique | BlueCMR', description: 'Document de Contrôle Numérique selon Loi 15/2009.', keywords: 'document contrôle', type: 'article' }
    }
  },
  cartaPorte: {
    langs: ['es'], // Solo existe indexada en ES. La versión EN no está prerrenderizada ni en sitemap.
    slug: { es: 'documentos/carta-porte', en: 'en/documents/road-waybill', fr: 'fr/documents/lettre-voiture' },
    seo: {
      es: { title: 'Carta de porte digital: requisitos de la Ley 15/2009 y DeCA | BlueCMR', description: 'La carta de porte nacional en formato electrónico: contrato, documento de control y prueba de entrega en un solo documento, con todo lo que exigen los artículos 10 y 10 bis.', keywords: 'carta de porte digital, ley 15/2009, carta de porte y deca', type: 'article' },
      en: { title: 'Digital consignment note for Spain (Law 15/2009) | BlueCMR', description: 'The Spanish domestic consignment note (carta de porte) in electronic form: contract, control document and proof of delivery in a single document.', keywords: 'carta de porte, spanish consignment note, law 15/2009', type: 'article' },
      fr: { title: 'Lettre de Voiture Numérique | BlueCMR', description: 'Lettre de Voiture Numérique avec validité légale.', keywords: 'lettre voiture numérique', type: 'article' }
    }
  },
  transporteAdr: {
    langs: ['es', 'en'], // EN desde el 4-nov-2026; FR no existe
    slug: { es: 'documentos/transporte-adr', en: 'en/documents/adr-transport-document' },
    seo: {
      en: {
        title: 'Digital ADR transport document, combined with the DeCA | BlueCMR',
        description: 'The dangerous goods transport document (ADR 5.4) in digital form: what it must contain and how to issue it with BlueCMR in a single document with Spain’s DeCA.',
        keywords: 'adr transport document, adr document, adr 5.4.1, dangerous goods transport document, digital adr, adr 1.1.3.6, adr spain, deca',
        type: 'article'
      },
      es: {
        title: 'Documento de transporte ADR digital, junto al DeCA | BlueCMR',
        description: 'El documento de transporte de mercancías peligrosas (ADR 5.4) en formato digital: qué debe contener y cómo emitirlo con BlueCMR en un solo documento con el DeCA.',
        keywords: 'documento transporte adr, carta de porte adr, adr mercancias peligrosas',
        type: 'article'
      }
    }
  }
};

// Generar todas las rutas con hreflang
export function getAllRoutes() {
  const routes = [];
  const allPages = { ...PAGES, ...DOCUMENT_PAGES };
  
  Object.entries(allPages).forEach(([pageKey, page]) => {
    // Idiomas en los que realmente existe la página (por defecto, todos)
    const pageLangs = page.langs || LANGUAGES;

    pageLangs.forEach(lang => {
      const slug = page.slug[lang];
      const path = slug ? `/${slug}` : '/';
      const seo = page.seo[lang];
      const alternates = {};
      
      // Solo declarar hreflang hacia idiomas que existen para esta página
      pageLangs.forEach(altLang => {
        const altSlug = page.slug[altLang];
        alternates[altLang] = altSlug ? `${BASE_URL}/${altSlug}` : BASE_URL;
      });
      // x-default apunta al idioma por defecto si existe, si no al primer idioma disponible
      const defaultLang = pageLangs.includes(DEFAULT_LANG) ? DEFAULT_LANG : pageLangs[0];
      const defaultSlug = page.slug[defaultLang];
      alternates['x-default'] = defaultSlug ? `${BASE_URL}/${defaultSlug}` : BASE_URL;

      // Si la página solo existe en un idioma, no tiene sentido emitir hreflang
      const finalAlternates = pageLangs.length > 1 ? alternates : undefined;
      
      routes.push({
        path,
        lang,
        pageKey,
        seo: { ...seo, canonical: path === '/' ? BASE_URL : `${BASE_URL}/${slug}` },
        alternates: finalAlternates
      });
    });
  });
  return routes;
}

export function getAllPublicRoutes() {
  return getAllRoutes().map(r => r.path);
}

export function getSeoConfig() {
  const config = {};
  getAllRoutes().forEach(route => {
    config[route.path] = { ...route.seo, alternates: route.alternates };
  });
  return config;
}

export { BASE_URL, DEFAULT_LANG, LANGUAGES };
